<template>
  <el-container>
    <el-header>
      <div class="header flex justify-content_flex-between align-items_center">
        <div style="overflow: hidden;height: 90%;padding: 3px 0;">
          <img style="height: 110px;margin-top: -35px;" src="../assets/logo.png" alt="" srcset="">
        </div>
        <div class="title">体检（体测）管理中心</div>
        <el-icon title="退出登录" size="24" class="icon" @click="handleClose">
          <SwitchButton />
        </el-icon>
      </div>
    </el-header>
    <el-container>
      <el-aside width="240px">
        <el-menu router :default-active="defaultActive" class="menu">
          <el-sub-menu index="1">
            <template #title>
              <el-icon>
                <CollectionTag />
              </el-icon>
              <span>瑞慈平台</span>
            </template>
            <el-menu-item index="/rich/order">
              <el-icon>
                <Postcard />
              </el-icon>
              <span>预约单管理</span>
            </el-menu-item>
            <el-menu-item index="/rich/personList">
              <el-icon>
                <User />
              </el-icon>
              <span>个人用户/体检人</span>
            </el-menu-item>
            <el-menu-item index="/rich/teamList">
              <el-icon>
                <User />
              </el-icon>
              <span>团检用户</span>
            </el-menu-item>
            <el-menu-item index="/rich/shopInfo">
              <el-icon>
                <TakeawayBox />
              </el-icon>
              <span>门店信息</span>
            </el-menu-item>
            <el-menu-item index="/rich/comboInfo">
              <el-icon>
                <Memo />
              </el-icon>
              <span>套餐信息</span>
            </el-menu-item>
            <el-menu-item index="/rich/comboItemInfo">
              <el-icon>
                <DocumentCopy />
              </el-icon>
              <span>套餐项目信息</span>
            </el-menu-item>
            <el-menu-item index="/rich/refersh_RC_Code">
              <el-icon>
                <Refresh />
              </el-icon>
              <span>重置登录</span>
            </el-menu-item>
          </el-sub-menu>
          <el-menu-item index="/feedback">
            <el-icon>
              <ChatLineSquare />
            </el-icon>
            <span>意见反馈</span>
          </el-menu-item>
          <el-menu-item index="/description">
            <el-icon>
              <Coin />
            </el-icon>
            <span>公共描述</span>
          </el-menu-item>
          <el-sub-menu index="2">
            <template #title>
              <el-icon>
                <Scissor />
              </el-icon>
              <span>理发预约</span>
            </template>
            <!-- <el-menu-item index="/haircut/list">
              <el-icon>
                <Memo />
              </el-icon>
              <span>理发预约列表</span>
            </el-menu-item> -->
            <el-menu-item index="/haircut/control">
              <el-icon>
                <Setting />
              </el-icon>
              <span>理发预约管理</span>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      <el-main><router-view /></el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { Memo, Postcard, SwitchButton, Refresh, TakeawayBox, CollectionTag, User, ChatLineSquare, Coin, DocumentCopy, Scissor, Setting } from "@element-plus/icons-vue";
import { ElMessageBox } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { onMounted, ref } from "vue";
const router = useRouter();
const handleClose = () => {
  ElMessageBox.confirm("确认退出登录？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
    closeOnClickModal: false,
  }).then(() => {
    $cookies.remove("token");
    router.push({
      path: "/login",
    });
  }).catch(() => {

  })
};
const defaultActive = ref('/studentManage')
onMounted(() => {
  defaultActive.value = useRoute().path
});
</script>

<style scoped lang="scss">
.el-header {
  padding: 0;
  background-color: #0051b7;
  color: #fff;

  .header {
    height: 100%;
    padding: 0 20px;

    .title {
      font-size: 20px;
    }

    .icon {
      font-size: 24px;
      cursor: pointer;
      padding: 14px;
    }
  }
}

.menu {
  width: 240px;
  height: 100%;
}

.el-main {
  padding: 0;
  text-align: left;
  overflow-y: hidden;
}

.el-menu-item.is-active {
  background-color: #eaeeff;
  color: #0051b7;
}
</style>
